<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="$t('Criar Grupo')"
        centered
        @hidden="cancelar"
        id="create-group"
    >
        <form @submit.prevent="submit">
            <div class="row">
                <form-input
                    v-model="title_group"
                    label="Nome do Grupo"
                    :required="true"
                />
                <label class="col-12 d-block font-weight-bold mb-2">
                    Quem vai participar do grupo
                </label>
                <div class="col-12 mb-2" v-for="user in users" :key="user.id">
                    <toggle-button
                        :sync="true"
                        color="#5685D8"
                        v-model="users_selected[user.id]"
                    />
                    <label class="ml-1">
                        {{ user.value }}
                    </label>
                </div>
            </div>
            <div class="row pt-4 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>
<script>
export default {
    props: ["item", "contacts"],
    data() {
        return {
            loading: false,
            title_group: "",
            users: [],
            users_selected: [],
        };
    },
    mounted() {
        this.users = this.contacts.map((user) => {
            return { id: user.id, value: user.name };
        });
    },
    methods: {
        submit() {
            var unidade_id_save = localStorage.getItem("unidade-chat-selected");
            axios
                .post(`api/dashboard/chat/group/store`, {
                    name: this.title_group,
                    unidade_id: unidade_id_save,
                    users: this.users_selected,
                })
                .finally(() => {
                    this.$emit("create");
                    this.cancelar();
                });
        },
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$emit("cancelado");
            this.$bvModal.hide("create-group");
        },
    },
};
</script>
